import React from 'react';

import ItemsPreview from '../../common/ItemsPreview/ItemsPreview';

export default function CartPreview(props) {
    return <ItemsPreview
        products={props.products}
        cards={props.cards}
        emptyText="Cosul nu are produse"
        getProductQuantity={(product) => product.CartProduct.quantity}
        getCardQuantity={(card) => card.CartCard.quantity}
        productImageBucket={process.env.REACT_APP_PRODUCT_IMAGE_BUCKET}
        cardImageBucket={process.env.REACT_APP_CARD_IMAGE_BUCKET}
        productImagePrefix="thumb_"
        productImageSuffix=".webp"
    />
}